import React from 'react'

export const IconEloCard = () => (
  <svg
    width="35"
    height="24"
    viewBox="0 0 35 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_532:3638)">
      <path
        d="M2.04078 7.71689e-05H33.3435C33.5611 -0.000394375 33.7767 0.0421199 33.9778 0.12518C34.1789 0.208241 34.3617 0.330217 34.5156 0.484095C34.6695 0.637974 34.7914 0.820727 34.8745 1.02187C34.9575 1.22301 35.0001 1.43858 34.9996 1.6562V22.3435C35.0001 22.5611 34.9575 22.7767 34.8745 22.9778C34.7914 23.179 34.6695 23.3617 34.5156 23.5156C34.3617 23.6695 34.1789 23.7914 33.9778 23.8745C33.7767 23.9576 33.5611 24.0001 33.3435 23.9996H2.04078C1.12359 23.9996 0.385013 23.2612 0.385013 22.3381V1.65077C0.384557 1.43318 0.427085 1.21763 0.510155 1.01652C0.593225 0.815401 0.715202 0.632675 0.869082 0.478828C1.02296 0.32498 1.20571 0.203039 1.40685 0.120011C1.60798 0.0369831 1.82353 -0.00550241 2.04113 -0.00500049L2.04078 7.71689e-05Z"
        fill="#333"
      />
      <path
        d="M7.74669 9.49057C8.04692 9.38903 8.36919 9.33595 8.70473 9.33595C10.1706 9.33595 11.3935 10.378 11.6717 11.76L13.7469 11.3361C13.27 8.98726 11.195 7.2168 8.70473 7.2168C8.13519 7.2168 7.58769 7.30945 7.0755 7.48172L7.74669 9.49057Z"
        fill="#FFF100"
      />
      <path
        d="M5.29624 16.2192L6.70024 14.6297C6.07324 14.0733 5.68024 13.2654 5.68024 12.3602C5.67931 11.9319 5.76982 11.5082 5.94572 11.1176C6.12161 10.727 6.37885 10.3785 6.70024 10.0952L5.29624 8.51019C4.23217 9.45508 3.56097 10.8283 3.56097 12.3647C3.56097 13.8968 4.23217 15.2743 5.29624 16.2192Z"
        fill="#00A3DF"
      />
      <path
        d="M11.6714 12.9697C11.3888 14.3516 10.1702 15.3893 8.70435 15.3893C8.36882 15.3893 8.04655 15.3362 7.74182 15.2347L7.07074 17.2435C7.59735 17.4197 8.14907 17.5091 8.70435 17.5084C11.1946 17.5084 13.2697 15.7424 13.7465 13.3935L11.6714 12.9697Z"
        fill="#EE4023"
      />
      <path
        d="M20.6612 14.3914C20.3168 14.7271 19.8533 14.9302 19.3409 14.9213C19.0024 14.9175 18.6718 14.818 18.3873 14.6343L17.6984 15.7293C18.1709 16.025 18.7228 16.2017 19.3234 16.2105C20.1932 16.2237 20.9878 15.8793 21.5663 15.3185L20.6612 14.3914ZM19.4162 9.92766C17.6854 9.90112 16.2549 11.2876 16.2283 13.0184C16.2194 13.6674 16.4049 14.2766 16.736 14.78L22.4227 12.3473C22.1049 10.983 20.8863 9.9542 19.4161 9.92766H19.4162ZM17.5307 13.2655C17.5218 13.1923 17.5174 13.1186 17.5175 13.0448C17.5352 12.0248 18.374 11.2081 19.3939 11.2257C19.6581 11.229 19.9185 11.2895 20.157 11.403C20.3956 11.5166 20.6067 11.6805 20.7759 11.8835L17.5307 13.2655ZM24.2109 8.51477V14.5769L25.2618 15.0139L24.7629 16.2105L23.7208 15.7778C23.4868 15.6762 23.3278 15.5216 23.2086 15.3451C23.0938 15.1685 23.0056 14.9212 23.0056 14.5945V8.51489H24.2109V8.51477ZM28.0036 11.3184C28.193 11.2559 28.3914 11.2246 28.5909 11.2257C29.4871 11.2257 30.2289 11.8615 30.4011 12.7049L31.6682 12.4443C31.3768 11.0094 30.1097 9.93204 28.5909 9.93204C28.2421 9.93204 27.9065 9.9895 27.5974 10.091L28.0036 11.3184ZM26.5068 15.4202L27.3634 14.4533C26.9792 14.1132 26.7408 13.6188 26.7408 13.0668C26.7408 12.5148 26.9837 12.0205 27.3634 11.6848L26.5068 10.7179C25.8579 11.292 25.4472 12.1352 25.4472 13.0713C25.4472 14.0074 25.8579 14.8462 26.5068 15.4202ZM30.401 13.4422C30.2289 14.2855 29.4827 14.9212 28.5909 14.9212C28.3878 14.9212 28.1891 14.8859 28.0036 14.8241L27.593 16.0516C27.9145 16.1601 28.2516 16.2152 28.5909 16.2149C30.1097 16.2149 31.3768 15.1376 31.6682 13.7027L30.4011 13.4422H30.401Z"
        fill="white"
      />
    </g>
    <path
      d="M4.38464 1H31V-1H4.38464V1ZM34 4V20H36V4H34ZM31 23H4.38464V25H31V23ZM1.38464 20V4H-0.615356V20H1.38464ZM4.38464 23C2.72779 23 1.38464 21.6569 1.38464 20H-0.615356C-0.615356 22.7614 1.62322 25 4.38464 25V23ZM34 20C34 21.6569 32.6569 23 31 23V25C33.7615 25 36 22.7614 36 20H34ZM31 1C32.6569 1 34 2.34315 34 4H36C36 1.23858 33.7614 -1 31 -1V1ZM4.38464 -1C1.62322 -1 -0.615356 1.23858 -0.615356 4H1.38464C1.38464 2.34315 2.72779 1 4.38464 1V-1Z"
      fill="#CCCCCC"
    />
    <defs>
      <linearGradient
        id="paint0_linear_532:3638"
        x1="20.6093"
        y1="15.832"
        x2="16.0827"
        y2="8.93546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#333333" />
        <stop offset="0.352" stopColor="#333333" />
        <stop offset="0.52" stopColor="#4D4D4D" />
        <stop offset="1" stopColor="#4D4D4D" />
      </linearGradient>
      <clipPath id="clip0_532:3638">
        <path
          d="M0.384644 4C0.384644 1.79086 2.1755 0 4.38464 0H31C33.2092 0 35 1.79086 35 4V20C35 22.2091 33.2092 24 31 24H4.38464C2.17551 24 0.384644 22.2091 0.384644 20V4Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
